import { CloseOutlined } from '@ant-design/icons';
import { Input, InputNumber, Select } from 'antd';
import { PaymentMethod, PAYMENT_METHOD_TEXT } from '~/types/Payment';
import { usePaymentAccountOptions } from '../../state/paymentAccounts';
import AutoSelectButton from '../AutoSelectButton';

const SplitPaymentItem = ({
  method,
  amount,
  description,
  onChangeAmount,
  onChangeDescription,
  onRemove,
}: {
  method: PaymentMethod;
  amount: number;
  description: string;
  onChangeAmount: (val: number | null) => void;
  onChangeDescription: (val: string) => void;
  onRemove: () => void;
}) => {
  const paymentAccountOptions = usePaymentAccountOptions();

  const onAutoSelect = (val: string) => {
    onChangeDescription(val);
  };

  return (
    <div style={{ marginBottom: 40 }} key={method}>
      <div className="flex justify-between items-center mb-1">
        <p className="text-lg mb-0 font-medium">
          {PAYMENT_METHOD_TEXT[method]}
        </p>
        <CloseOutlined onClick={onRemove} />
      </div>
      <InputNumber
        value={amount}
        onChange={onChangeAmount}
        style={{ width: '100%', textAlign: 'right', marginBottom: 8 }}
        size="large"
      />
      {method !== PaymentMethod.Cash ? (
        method === PaymentMethod.Other ? (
          <Input
            placeholder="Deskripsi"
            onChange={(event) => onChangeDescription(event.target.value)}
            size="large"
          />
        ) : (
          <div className="flex gap-1">
            <AutoSelectButton onSelect={onAutoSelect} />
            <Select
              value={description !== '' ? description : undefined}
              placeholder={`Pilih ${PAYMENT_METHOD_TEXT[method]}`}
              options={paymentAccountOptions}
              className="w-full"
              size="large"
              onSelect={(value: string) => onChangeDescription(value)}
            />
          </div>
        )
      ) : null}
    </div>
  );
};

export default SplitPaymentItem;
